import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
const stateOrTagTypes = ['', 'success', 'warning', 'danger', 'info'];
const stateOrTagTypeLength = stateOrTagTypes.length;
const useContentTag = '{value}';
let AmTableColumnTemplateMixin = class AmTableColumnTemplateMixin extends Vue {
  get isTagType() {
    return this.config.type === 'tag';
  }
  get values() {
    return this.config.values.filter(value => !!value);
  }
  get stateOrTagTypes() {
    return !this.isTagType ? stateOrTagTypes : stateOrTagTypes.filter((_, index) => !!this.config.values[index]);
  }
  get stateType() {
    return this.stateOrTagTypes[this.index % stateOrTagTypeLength];
  }
  get valueIndex() {
    return this.index % this.values.length;
  }
  get valueContent() {
    const target = this.values[this.valueIndex];
    if (!this.isTagType) return target;
    return target === useContentTag ? this.content : target;
  }
  get tagType() {
    return this.stateOrTagTypes[this.valueIndex];
  }
};
__decorate([Prop(Object)], AmTableColumnTemplateMixin.prototype, "config", void 0);
__decorate([Prop(Number)], AmTableColumnTemplateMixin.prototype, "index", void 0);
__decorate([Prop(String)], AmTableColumnTemplateMixin.prototype, "content", void 0);
AmTableColumnTemplateMixin = __decorate([Component({
  name: 'AmTableColumnTemplateMixin'
})], AmTableColumnTemplateMixin);
export default AmTableColumnTemplateMixin;